import { c as _c } from "react/compiler-runtime";
import { Box, Heading } from '@chakra-ui/react';
import { SupportOptionsBlock } from '@src/components/sco/SupportOptionsBlock';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React from 'react';
type AccountAsideProps = {};
export const AccountAside = props => {
  const $ = _c(1);
  useCurrentUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box bgColor="backgroundSecondary" overflow="auto" padding="1em" width="full"><Heading fontSize="16px" paddingBottom="1em" textAlign="center">Contact Us For Additional Help</Heading><SupportOptionsBlock /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};